const CHURNKEY_SCRIPT_URL = 'https://assets.churnkey.co/js/app.js';
const READY_POLL_INTERVAL_MS = 50;
const READY_TIMEOUT_MS = 10000;

const isChurnkeyReady = () => Boolean(window.churnkey?.init && window.churnkey?.check);

/**
 * The head snippet sets `window.churnkey = { created: true }` synchronously but the SDK
 * itself loads async, so `created` alone is not enough to know the API is callable.
 */
const waitForChurnkey = () => new Promise((resolve, reject) => {
  if (isChurnkeyReady()) {
    resolve();
    return;
  }

  const startedAt = Date.now();

  const poll = setInterval(() => {
    if (isChurnkeyReady()) {
      clearInterval(poll);
      resolve();
      return;
    }

    if (Date.now() - startedAt >= READY_TIMEOUT_MS) {
      clearInterval(poll);
      reject(new Error('Timed out waiting for the Churnkey script to load'));
    }
  }, READY_POLL_INTERVAL_MS);
});

/**
 * Loads the Churnkey SDK if it is not already on the page and resolves once it is callable.
 */
export const loadChurnkey = (appId) => {
  if (isChurnkeyReady()) {
    return Promise.resolve();
  }

  if (!window.churnkey || !window.churnkey.created) {
    window.churnkey = { created: true };

    const script = document.createElement('script');
    script.src = `${CHURNKEY_SCRIPT_URL}?appId=${appId}`;
    script.async = true;
    document.head.appendChild(script);
  }

  return waitForChurnkey();
};
